import ProptradingPage from './ProptradingPage';

export default ProptradingPage;
